// 生成资源预设的分类内容
import { Category } from '@/types/dmaker/info.type'
import { GameDifficulty } from '@/types/dmaker/game-config.type'
import {
  createFeGameConfigCategoryId,
  presetConfigCategoryResourceType,
  presetCategoryResourceType,
  isPresetCategory,
  isPresetOptionCategory,
  presetConfigParentCategoryType,
} from '@/store/creative/common/category'
import { getPresetOptionValue } from '@/views/creative/utils/preset-utils'

export default function generatePresetCategory(
  category: Category[],
): Category[] {
  const presetCategory: Category[] = []

  const presetConfigParentCategory = {
    id: createFeGameConfigCategoryId(),
    is_define: 0,
    is_edit: 0,
    name: '预设',
    name_en: 'Preset',
    pid: 0,
    res_type: 0,
    sort_id: 0,
    prefix: presetConfigParentCategoryType,
    resource_type: presetConfigParentCategoryType,
    sub_category: [],
  }

  category.forEach((item) => {
    if (isPresetCategory(item)) {
      if (!presetCategory.some((i) => i.prefix === 'presetConfigParent')) {
        presetCategory.push(presetConfigParentCategory)
      }
      presetCategory[0].sub_category.push({
        id: createFeGameConfigCategoryId(),
        is_define: 0,
        is_edit: 0,
        name: item.name,
        name_en: item.name_en,
        pid: item.id,
        res_type: 0,
        sort_id: 0,
        prefix: item.prefix,
        resource_type: presetConfigCategoryResourceType,
      })
      if (item.sub_category.length) {
        item.sub_category.forEach((subItem) => {
          if (isPresetOptionCategory(subItem)) {
            presetCategory.push({
              ...subItem,
              pid: item.pid,
            })
          }
        })
      }
    }
  })

  return presetCategory
}

/**
 * 通过后端返回的分类信息，生成预设配置 config 参考 gameConfig
 * @param category
 * @param defaultConfig 默认传参，如果后端有生成，则使用后端生成的 config 中的 value 作为 default value
 */
export function generatePresetConfig(
  category: Category[],
  defaultConfig?: {
    [key: string]: { value: string; options: { value: string }[] }
  },
): GameDifficulty {
  const presetConfig: GameDifficulty = {}
  category.forEach((item) => {
    if (item.resource_type === presetCategoryResourceType) {
      let value
      if (
        defaultConfig &&
        defaultConfig[item.prefix] &&
        defaultConfig[item.prefix].value
      ) {
        value = defaultConfig[item.prefix].value
      } else {
        value = getPresetOptionValue(item.sub_category[0])
      }
      presetConfig[item.prefix] = {
        type: 'radio',
        options: item.sub_category!.map((subItem) => {
          return {
            label: subItem.name,
            text: subItem.name, // 历史产物，要支持 text
            value: getPresetOptionValue(subItem),
          }
        }),
        options_en: item.sub_category!.map((subItem) => {
          return {
            label: subItem.name_en || subItem.name,
            text: subItem.name_en || subItem.name, // 历史产物，要支持 text
            value: getPresetOptionValue(subItem),
          }
        }),
        value,
        mw_mapping_path: `[presetConfig][${item.prefix}]`,
      }
    }
  })
  return presetConfig
}
